import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/*
 * Displays `text` using a simple type-writer effect, appending one character
 * every `speed` milliseconds. Re-starts the effect whenever `text` changes.
 */
const TypewriterText = ({ text, speed = 15, cssClassName, onComplete }) => {

  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    // Reset when text changes
    setDisplayed('');
    if (!text) return;

    let index = 0;
    const timer = window.setInterval(() => {
      index += 1;
      setDisplayed(text.slice(0, index));
      if (index >= text.length) {
        window.clearInterval(timer);
        onComplete && onComplete();
      }
    }, speed);

    return () => window.clearInterval(timer);
  }, [text, speed, onComplete]);

  return <div className={cssClassName} dangerouslySetInnerHTML={{ __html: displayed }} />;
};

TypewriterText.propTypes = {
  text: PropTypes.string,
  speed: PropTypes.number,
  cssClassName: PropTypes.string,
  onComplete: PropTypes.func
};

export default TypewriterText; 


// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/typewriter_text.jsx